export default "{\n    \"placeholder\": \"Describe your task\"\n}\n"